// @flow
import * as React from 'react';
import type { HOC as ElementType } from 'recompose';
import { Circle } from './../Circle';
import type { circleType } from './../../types';

export const withCircle = (Comp: ElementType) => ({
  outline,
  radius,
  outlineStyle = {
    border: '0.5px solid var(--color-grey-3)',
  },
  filledStyle = {
    background: 'var(--color-mercari-blue)',
  },
  ...props
}: circleType) => (
  <Circle
    outline={outline}
    radius={radius}
    outlineStyle={outlineStyle}
    filledStyle={filledStyle}
  >
    <Comp {...props} outline={outline} />
  </Circle>
);
